<app-layout>
  @if (gdprView) {
    <div class="px-[0.88rem] md:pt-[4.5rem]" primary>
      @if (response.surveyTitle) {
        <h1
          class="font-normal text-[2.5rem] text-inherit mb-6"
          [innerHTML]="response.surveyTitle | safeHtml"
        ></h1>
      }

      <div
        class="mb-6 rich-text-content"
        [innerHTML]="statement?.welcomeMessage || '' | safeHtml"
      ></div>
      <h2 class="font-normal text-[1.5rem] text-inherit mb-6">
        {{ "gdpr.statement.infoaboutdataprocessing" | translate }}
      </h2>
      <div
        class="mb-6 rich-text-content"
        [innerHTML]="statement?.purposeStatement || '' | safeHtml"
      ></div>
      <div class="2xl:flex 2xl:justify-between">
        <div class="">
          <h2 class="font-normal text-[1.5rem] text-inherit mb-2">
            {{
              "gdpr.statement.field.controllername.respondentname" | translate
            }}
          </h2>
          <div
            class=""
            [innerHTML]="
              statement?.controllerName || '' | newlineToBr | safeHtml
            "
          ></div>
          <div
            class=""
            [innerHTML]="
              statement?.controllerDetails || '' | newlineToBr | safeHtml
            "
          ></div>
        </div>

        <div *ngIf="statement?.representativeName" data-testid="rep-section">
          <h2 class="font-normal text-[1.5rem] text-inherit mb-2 mt-8 2xl:mt-0">
            {{
              "gdpr.statement.field.representativename.respondentname"
                | translate
            }}
          </h2>

          <div
            class=""
            [innerHTML]="
              statement?.representativeName || '' | newlineToBr | safeHtml
            "
          ></div>
        </div>
      </div>
      <div class="mt-8">
        <button
          class="text-left underline"
          (click)="openGdprStatements(moreInfo)"
        >
          {{ "gdpr.statement.getmoreinfo" | translate }}
        </button>
      </div>

      <div class="mt-8">
        <div
          class="lg:hover:font-bold flex items-center qb-checkbox qb-checkbox-outline transition-transform-slow lg:hover:scale-[1.02]"
        >
          <input
            type="checkbox"
            id="gdprCheckbox"
            name="gdprCheckbox"
            [(ngModel)]="gdprConsent"
            [attr.aria-required]="true"
            [attr.aria-invalid]="hasConsentError()"
            [attr.aria-describedby]="hasConsentError() ? 'gdpr-error' : null"
            [attr.aria-label]="'gdpr.statement.processingagree' | translate"
          />
          <label for="gdprCheckbox" class="ml-1 cursor-pointer">
            {{ "gdpr.statement.processingagree" | translate }}
          </label>
        </div>
        <p id="gdprConsentHelp" class="sr-only">
          {{ "gdpr.statement.processingagree" | translate }}
        </p>
        @for (item of error$ | async; track item) {
          @if (
            item.translationKey === "validation.general.missingconsentanswer"
          ) {
            <div id="gdpr-error" role="alert" aria-live="polite">
              <app-validator [validator]="validator.GdprConsentRequired" />
            </div>
          }
        }
      </div>

      <ng-template #moreInfo let-ref>
        <div appFocusTrap class="ngneat-dialog-focustrap">
          <div class="ngneat-close-dialog">
            <button
              [attr.aria-label]="
                'gdpr.statement.closedialog.button' | translate
              "
              [title]="'gdpr.statement.closedialog.button' | translate"
              (click)="ref.close()"
            >
              <img
                src="/assets/icons/x.svg"
                alt="{{ 'gdpr.statement.closedialog.button' | translate }}"
                aria-hidden="true"
                class="w-6"
              />
            </button>
          </div>
          <div
            class="mt-8 m-2 sm:m-4 md:m-6 lg:m-8 xl:m-12 2xl:m-16 overflow-y-auto max-h-[70vh]"
          >
            <h1 class="font-normal text-[2rem] text-inherit mb-6">
              {{ "gdpr.statement.infoaboutdataprocessing" | translate }}
            </h1>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.processingperiodcriteria.respondentname'
                  | translate
              "
              [value]="getDuration()"
              [afterText]="getAfterText() | translate"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.personaldatatypes.respondentname'
                  | translate
              "
              [value]="statement?.personalDataTypes"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.personaldatacategories.respondentname'
                  | translate
              "
              [value]="statement?.personalDataCategories"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.legalbasisforprocessing.respondentname'
                  | translate
              "
              [value]="statement?.legalBasisForProcessing"
            ></app-gdpr-statement>

            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.categoriesofrecipients.respondentname'
                  | translate
              "
              [value]="statement?.categoriesOfRecipients"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.transferofdataexternally.respondentname'
                  | translate
              "
              [value]="statement?.transferOfDataExternally"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.statutoryorcontractualreq.respondentname'
                  | translate
              "
              [value]="statement?.statutoryOrContractualReq"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.automateddecisionmaking.respondentname'
                  | translate
              "
              [value]="statement?.automatedDecisionMaking"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.datasubjectrights.respondentname'
                  | translate
              "
              [value]="statement?.dataSubjectRights"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.withdrawconsentinfo.respondentname'
                  | translate
              "
              [value]="statement?.withdrawConsentInfo"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.supervisoryauthorityinfo.respondentname'
                  | translate
              "
              [value]="statement?.supervisoryAuthorityInfo"
            ></app-gdpr-statement>
            <app-gdpr-statement
              [heading]="
                'gdpr.statement.field.dataprotectionofficer.respondentname'
                  | translate
              "
              [value]="statement?.dataProtectionOfficer"
            ></app-gdpr-statement>
          </div>
        </div>
      </ng-template>

      <ng-template #declineConsent let-ref>
        <div appFocusTrap class="ngneat-dialog-focustrap">
          <div class="ngneat-close-dialog">
            <button
              [attr.aria-label]="
                'gdpr.notparticipate.closedialog.button' | translate
              "
              [title]="'gdpr.notparticipate.closedialog.button' | translate"
              (click)="ref.close()"
            >
              <img
                src="/assets/icons/x.svg"
                alt="{{ 'gdpr.notparticipate.closedialog.button' | translate }}"
                aria-hidden="true"
              />
            </button>
          </div>
          <div
            class="mt-8 m-2 sm:m-4 md:m-6 lg:m-8 xl:m-12 2xl:m-16 overflow-y-auto max-h-[70vh] p-1"
          >
            <h1 class="font-normal text-[2rem] text-inherit mb-6">
              {{ "gdpr.statement.notparticipate.dialogheader" | translate }}
            </h1>
            <div>
              {{ "gdpr.statement.notparticipate.dialogcontent" | translate }}
            </div>
            <div class="flex mt-8 mb-2 sm:mb-0">
              <app-button
                class="w-36 mr-8"
                buttonId="declineConsentOk"
                [buttonText]="'OK'"
                customClasses="title-dynamic-theme border-solid border-2 px-3 py-2"
                (buttonClick)="ref.close(); declineGdpr()"
              >
              </app-button>
              <app-button
                class="w-36"
                buttonId="declineConsentCancel"
                [buttonText]="'gdpr.notparticipate.cancel.button' | translate"
                customClasses="px-3 py-2"
                (buttonClick)="ref.close()"
              ></app-button>
            </div>
          </div>
        </div>
      </ng-template>

      <div class="mt-6">
        <app-button
          (buttonClick)="openGdprDecline(declineConsent)"
          buttonId="gdpr-btn"
          [buttonText]="'gdpr.statement.notparticipate' | translate"
          [description]="'gdpr.statement.notparticipate' | translate"
          type="submit"
          customClasses="validation-dynamic-theme border-solid border-2 !w-fit p-2"
        ></app-button>
      </div>
    </div>
  }
  @if (chooseLanguageComponent) {
    <app-choose-language
      appLanguage
      class="mr-2 lg:mr-4"
      (selectedLanguage)="setLanguage($event)"
      [defaultLanguage]="response.language"
      [showFlags]="chooseLanguageComponent.showFlags"
      [options]="languageOptions"
      [translationKeys]="gdprPageTranslationkeys"
      [fallbackLanguage]="response.fallbackLanguage"
    ></app-choose-language>
  }

  <app-navigation
    [disableNext]="!gdprConsent && useClientValidation"
    (nextClick)="gdprConsent || !useClientValidation ? next() : false"
    [nextButtonText]="'navigation.next.button' | translate"
    navigation
  ></app-navigation>
</app-layout>
